import { Component } from '@angular/core';
import { NgElement, WithProperties } from '@angular/elements';
import { AppState } from '../../core';
import { MapWaypoint } from '../../core/models';
import {LookupService, PointService, ScoutPointPhotoService} from '../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ScoutPointRefLauncher } from '../../core/services/scout-point-ref-launcher';
import { PathPlotterComponent } from '../../shared/mapping/path-plotter/path-plotter.component';
import { WaypointMarkerPopupComponent } from './waypoint-marker-popup/waypoint-marker-popup.component';



@Component({
  selector: 'app-waypoints-plotter',
  templateUrl: '../../shared/mapping/path-plotter/path-plotter.component.html',
  styleUrls: ['../../shared/mapping/path-plotter/path-plotter.component.scss']
})
export class WaypointsPlotterComponent extends PathPlotterComponent<MapWaypoint> {

  pathId : string
  
  constructor(
      appState: AppState,
      lookupService: LookupService,
      photoService: ScoutPointPhotoService,
      protected pointService: PointService,
      protected scoutPointRefLauncher: ScoutPointRefLauncher,
      modalService: BsModalService){
    super(appState,lookupService,photoService,modalService)
    this.markerPopupInitFn = this.waypointMarkerPopupInitFn
  }

  getColorFn = (point:MapWaypoint,index:number) => point.color
  
  waypointMarkerPopupInitFn = (startPoint:MapWaypoint) => {
    return (fl) => {
      const popupComp: NgElement & WithProperties<WaypointMarkerPopupComponent> = document.createElement('app-waypoint-marker-popup-element') as any;
      popupComp.addEventListener('closed', () => document.body.removeChild(popupComp));
      popupComp.pt = startPoint
      popupComp.selectedPt = this.points[this.selectedIndex]
      popupComp.changeGuard = this.changeGuard
      popupComp.deleteScoutPointFn = this.deletePointFn
      popupComp.setSelectedPointFn = this.setSelectedPoint
      popupComp.bShowSelectButton = this.canSelectViaPoints || startPoint.type != 'VIA'
      popupComp.showRefDataFn = this.showRefDataFn
      popupComp.pathId = this.pathId
      popupComp.allowEditMode = this.allowEditMode
      popupComp.locked = this.locked
      document.body?.appendChild(popupComp);
      const rtn : any = popupComp
      return rtn
    }
  }

  plotWaypoints( pathId: string, mapPoints : MapWaypoint[] ) {
    this.pathId = pathId
    this.plot(mapPoints)
  }

  plotWaypointsWhenReady( pathId: string, mapPoints : MapWaypoint[] ) {
    this.pathId = pathId    
    this.plotWhenReady(mapPoints)
  }

  showRefDataFn = async ( mapWaypoint : MapWaypoint ) => {
    const pointId = mapWaypoint?.pointId
    const point = pointId && await this.pointService.getById(pointId)
    if ( !point ) {
      this.appState.notifyWarning('Point not found for ID=' + pointId,this,15)
      return
    }
    const buildingId = point?.buildingId
    if ( !buildingId ) {
      this.appState.notifyWarning('No building ID for point ' + pointId,this,15)
      return
    }
    await this.scoutPointRefLauncher.showScoutPointRefData({
      buildingId,
      pathId: this.pathId,
      pointId,
      stage: null
    })
  }
}
